__turbopack_context__.v({
  "search_results_show_row": "SearchShowResults-module-scss-module__eB3sbq__search_results_show_row",
  "search_show_results_title": "SearchShowResults-module-scss-module__eB3sbq__search_show_results_title",
});
